import React from 'react'
import classnames from 'classnames'

const Description = ({ children, className }) => (
  <p
    className={classnames(
      'text-center text-sm font-tomatoGrotesk-reg text-white opacity-40 mt-5',
      className
    )}
  >
    {children}
  </p>
)

export default Description
